/**
 * push dataLayerEvents for vue-Login-Layer
 */

import pushDataLayer from "@ocm/services/dataLayer.js";

const getPageName = () => {
	window.dataLayer = window.dataLayer || {};
	const { pageName } = window.dataLayer.find((dataLayerEntry) => dataLayerEntry?.Recommendation)?.Recommendation
		?.pageData;
	return pageName;
};

const pushEvent = (category, action) => {
	const eventCategory = `S_${category}`;
	const eventAction = `S_${action}`;
	const pageName = getPageName();

	const eventObj = {
		event: "GAevent",
		event_category: eventCategory,
		event_action: eventAction,
		event_label: `S_${pageName}`,
	};

	pushDataLayer(eventObj);
};

export { pushEvent };
